module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/7_2e0ef3e0028e53eb3ccbfb9dcc492ab4.jpg";